/**
 * EmojiScale — 1-5 emoji-based STATUS picker for U8-U11.
 *
 * UX:
 *   - Only used for STATUS questions per RATING PHILOSOPHY §1.4.
 *   - Large 60+ px tap targets for kids' fingers.
 *   - No numbers visible (kids respond to the face, not the score).
 *   - Selected emoji animates lightly to confirm tap.
 */
import React from "react";

const FACES = [
  { value: 1, char: "😞", label: "Inte alls bra" },
  { value: 2, char: "😟", label: "Lite trött" },
  { value: 3, char: "😐", label: "Okej" },
  { value: 4, char: "🙂", label: "Bra" },
  { value: 5, char: "😍", label: "Toppen" },
];

export default function EmojiScale({ value, onChange, qid }) {
  return (
    <div data-testid={`emoji-scale-${qid}`} className="w-full">
      <div className="grid grid-cols-5 gap-2">
        {FACES.map((f) => {
          const active = value === f.value;
          return (
            <button
              key={f.value}
              type="button"
              data-testid={`emoji-${qid}-${f.value}`}
              aria-label={f.label}
              aria-pressed={active}
              onClick={() => onChange(f.value)}
              className={`relative h-20 rounded-3xl border text-4xl flex items-center justify-center transition-all duration-200 active:scale-95 ${
                active
                  ? "bg-[rgb(var(--tn-bg-fffbeb))] border-amber-300 shadow-[0_8px_20px_rgba(245,158,11,0.25)] scale-105"
                  : "bg-white border-[rgb(var(--tn-border-e4e4e7))] hover:bg-[rgb(var(--tn-bg-fafafa))] dark:bg-[rgb(var(--tn-bg-18181b))] dark:border-[rgb(var(--tn-border-27272a))] grayscale-[30%]"
              }`}
            >
              <span className={active ? "" : "opacity-75"}>{f.char}</span>
            </button>
          );
        })}
      </div>
      <p className="mt-3 text-center text-xs text-[rgb(var(--tn-text-71717a))]">
        {value
          ? FACES.find((f) => f.value === value)?.label
          : "Tryck på den som passar bäst"}
      </p>
    </div>
  );
}
